<template>
  <b-form-input
    :value="$props.value"
    placeholder="Search"
    size="sm"
    class="base-search-input"
    @input="onInput"
  ></b-form-input>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { debounce } from 'lodash-es'

export default defineComponent({
  name: 'BaseSearchInput',
  props: {
    value: String
  },
  emits: ['input'],
  setup(_, { emit }) {
    const onInput = debounce((value) => emit('input', value), 500)

    return {
      onInput
    }
  }
})
</script>
